<template>
  <div
    :disabled="loading"
    data-quick-reply-item
    class="tw-flex tw-items-center tw-border-t-1 tw-py-3 tw-pl-6 tw-pr-6 hover:tw-cursor-pointer hover:tw-bg-dynamic-primary-light-9"
    @click="optionClickEventHandler(option)"
    @mouseover="handleMouseOver(option)"
    @mouseleave="handleMouseLeave"
  >
    <div class="tw-flex tw-items-center tw-flex-1">
      <AppText
        data-quick-reply-item-text
        :color="active ? 'primary' : 'secondary'"
        :weight="active ? 'bold' : undefined"
      >
        {{ option }}
      </AppText>
    </div>

    <div
      data-quick-reply-item-icon-container
      class="tw-flex tw-basis-[4.2rem] tw-items-center tw-justify-end tw-transition-transform tw-duration-300 tw-ease-in-out"
      :class="{ 'tw-translate-x-5': active }"
    >
      <AppText
        size="sm"
        color="primary"
        weight="extrabold"
        data-quick-reply-item-icon-text
        :class="[
          'tw-break-keep tw-opacity-0 tw-scale-95 tw-pointer-events-none tw-transition-all tw-duration-[800ms] tw-ease-[cubic-bezier(0.4, 0, 0.2, 1)]',
          { 'tw-opacity-100 tw-scale-100 tw-pointer-events-auto': active },
        ]"
      >
        {{ t('pt.messages.quickReply.send') }}
      </AppText>

      <AppIcon
        shape="play-custom"
        size="30"
        color="primary"
        :solid="active"
        data-quick-reply-item-icon
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n'

import { useWindowSize } from '@shared/composables/use-window-size'
import { Nullable } from '@shared/models/types/primary'

const props = withDefaults(
  defineProps<{
    active: boolean
    option: string
    loading: boolean
  }>(),
  {
    loading: false,
  }
)

const emit = defineEmits<{
  (event: 'send-message', option: string): void
  (event: 'set-active', option: Nullable<string>): void
}>()

const { t } = useI18n()
const { isSmallScreen } = useWindowSize()

const handleMouseOver = (option: string) => {
  if (isSmallScreen.value) {
    return
  }
  emit('set-active', option)
}

const handleMouseLeave = () => {
  if (isSmallScreen.value) {
    return
  }
  emit('set-active', null)
}
const optionClickEventHandler = (option: string) => {
  if (!props.active && isSmallScreen.value) {
    emit('set-active', option)
  } else {
    emit('send-message', option)
  }
}
</script>
